/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { DefaultContainerLayout } from '@/data/types/ContainerLayout';

const Layout: DefaultContainerLayout = {
	id: '',
	name: 'DoubleStack',
	containerName: 'error-404-page',
	isStoreDefault: true,
	slots: [],
};

export default Layout;
